import {Component, Input} from '@angular/core';

@Component({
    selector: 'dashlet',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class Dashlet {
  @Input() title: string;
  @Input() loading: boolean;
  @Input() noResults: boolean;
}
